import {
    useEffect
} from "react";

// Lightweight SEO hook: sets document title, meta description and JSON-LD.
export function useSEO({
    title,
    description,
    jsonLd,
    canonical
}) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (name, content) => {
            if (!content) return;
            let el = document.querySelector(`meta[name="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute("name", name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        setMeta("description", description);

        // canonical
        if (canonical) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        }

        // JSON-LD structured data
        let script = document.getElementById("route-jsonld");
        if (jsonLd) {
            if (!script) {
                script = document.createElement("script");
                script.type = "application/ld+json";
                script.id = "route-jsonld";
                document.head.appendChild(script);
            }
            script.textContent = JSON.stringify(jsonLd);
        }
        return () => {
            const s = document.getElementById("route-jsonld");
            if (s) s.remove();
        };
    }, [title, description, jsonLd, canonical]);
}

export const ORG_JSONLD = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "ITL Technical Services",
    description: "Manufacturer and supplier of servo controlled AC voltage stabilizers, super isolation transformers and constant voltage transformers.",
    areaServed: "IN",
    makesOffer: [
        "Servo Voltage Stabilizer",
        "Isolation Transformer",
        "Constant Voltage Transformer",
    ],
};